/**
 * @generated SignedSource<<2c400a6ff9af150260f058edddb81cef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type MissionType = "EMPTY" | "GPS" | "MIXED" | "NAV" | "SITE" | "SURFACE_SCAN" | "%future added value";
export type SchedulesLogicEnum = "AND" | "OR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type missions_scheduledMission$data = {
  readonly active: boolean;
  readonly dock: {
    readonly displayName: string;
    readonly dockId: string;
  } | null;
  readonly endTriggers: {
    readonly condition: {
      readonly batteryPercentage: {
        readonly valueCondition: {
          readonly lessThan: {
            readonly value: number;
          };
        };
      } | null;
    } | null;
  } | null;
  readonly endTriggersJson: string | null;
  readonly id: string;
  readonly startTriggers: {
    readonly expression: {
      readonly logic: SchedulesLogicEnum;
      readonly predicates: ReadonlyArray<{
        readonly condition: {
          readonly weeklyCalendarEvent: {
            readonly calendarEvent: {
              readonly dayOfWeek: number;
              readonly hourOfDay: number;
              readonly minuteOfHour: number;
            };
            readonly maxTimeDelaySeconds: number;
          } | null;
        } | null;
        readonly uuid: string;
      }>;
    } | null;
    readonly uuid: string;
  };
  readonly startTriggersJson: string | null;
  readonly template: {
    readonly currentSpec: {
      readonly estimatedDuration: number | null;
      readonly missionType: MissionType | null;
      readonly ncpgFile: {
        readonly id: string;
        readonly isUploaded: boolean | null;
        readonly kind: string;
      } | null;
      readonly ncpgFileId: string | null;
      readonly numWaypoints: number | null;
      readonly takeoffPoint: {
        readonly site: {
          readonly name: string | null;
        } | null;
        readonly siteId: string;
      } | null;
    } | null;
    readonly id: string;
    readonly name: string;
    readonly timezone: string | null;
    readonly uuid: string;
  } | null;
  readonly uuid: string;
  readonly vehicle: {
    readonly displayName: string;
    readonly scheduledMissionsDisabled: boolean;
    readonly vehicleId: string;
  } | null;
  readonly " $fragmentType": "missions_scheduledMission";
};
export type missions_scheduledMission$key = {
  readonly " $data"?: missions_scheduledMission$data;
  readonly " $fragmentSpreads": FragmentRefs<"missions_scheduledMission">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "missions_scheduledMission"
};

(node as any).hash = "bc949dba944c8232343463fc088eea39";

export default node;
